import { RouteConfig } from 'vue-router';

import { permissionPlanner } from '../Middleware/permission/Planner';

export const NAME_ROUTES_PLANNER = {
  PLANNER: 'Planner',
  CONFIG: 'PlannerConfig'
};

export const Planner: Array<RouteConfig> = [
  {
    path: '/planner',
    component: () => import('@/layouts/Sidebar/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_PLANNER.PLANNER,
        component: () => import(/* webpackChunkName: "planner" */ '@/pages/Planner/Planner.vue'),
        meta: { title: 'Plano de estudos' },
        beforeEnter: permissionPlanner
      },
      {
        path: 'configuracao',
        name: NAME_ROUTES_PLANNER.CONFIG,
        component: () => import(
          /* webpackChunkName: "planner-config" */ '@/pages/Planner/pages/PlannerConfig/PlannerConfig.vue'
        ),
        meta: { title: 'Configuração do Plano de estudos' },
        beforeEnter: permissionPlanner
      }
    ]
  }
];
